import { FormControlLabel, Switch } from "@mui/material";
import React, { useState } from "react";
import { Form } from "react-bootstrap";
import moment from "moment";
import CommonDatePicker from "../../../../common/components/DatePickers/CommonDatePicker";
import CustomToggleButton from "../../../../common/components/CustomToggleButton";
import { AEDStorageInfo, SortByProperty } from "../../../../common/helper/BasicFn";
import GlobalDropdown from "../../../../common/components/custom-ui/GlobalDropdown";
import { printConsole } from "../../../../common/helper/Common";

function StorageInformation({
  AccountList,
  formData,
  BrandList,
  setFormData,
  keyName,
  Permissins,
}) {
  const handleInput = (e) => {
    let val = e.target.value;
    let name = e.target.name;
   printConsole("storage", val, name) // print console.log


    const fd = { ...formData };
    fd.alarmed = parseInt(val) === 1 ? 1 : 0; // val === 1 ? 1 : 0;
    fd.alarm_status = parseInt(val) === 1 ? 1 : 0;
    fd[name] = val;
    if(name==='storage_type'){
      const label = e.target.options[e.target.selectedIndex].text;
      fd['storage_part_name'] = label;
    }
    fd[name] = val;
    setFormData(fd);
  };

 printConsole('formDataNew2', formData); // print console.log

  const handleCheckBox = (e) => {
    if (e.target.type == "checkbox") {
      setFormData((old) => ({ ...old, [e.target.name]: e.target.checked }));
    } else {
      setFormData((old) => ({ ...old, [e.target.name]: e.target.value }));
    }
  };
  const [StorageList, setStorageList] = useState([]);
  const onLoad = async () => {
    let data = await AEDStorageInfo();
    if (data) {
      data = SortByProperty(data, "storage_info_name");
      setStorageList(data);
    }
  };

  // React.useEffect(() => {
  //   onLoad();
  // }, []);

  const handleCheckBox2 = (e) => {
    let name = e.target.name;
    let val = e.target.value;
    let checked = e.target.checked;

    const oldData = { ...formData };
    if (checked) {
      oldData[name] = 1;
    } else {
      oldData[name] = 0;
    }
    setFormData(oldData);
  };

  const handleAlarmStatus = (e) => {
    let name = e.target.name;
    let val = e.target.value;
    let checked = e.target.checked;

    const oldData = { ...formData };
    if (checked) {
      oldData[name] = 1;
    } else {
      oldData[name] = 0;
    }
    setFormData(oldData);
  };

  const handleDateChange = (name, val) => {
    let expiry_date = moment(val)
      .add(Permissins?.v_battery, "years")
      .calendar();
  
    const oldData = { ...formData };
    oldData.store_expiry_date = expiry_date;
    oldData.expiry_date = expiry_date;
    oldData[name] = val;
  
    setFormData(oldData);
  };
  
 printConsole({formData}) // print console.log

  return (
    <>
      <div className=" bg-gray py-4 px-4 my-2" id="aed_storage_info_section">
        <h2 className="heading">Storage Information</h2>
        <div className="row">
          <div className="col-4 form-group">
            <label htmlFor="">Storage Type</label>
            <GlobalDropdown
              dropDownName={"storage_type"}
              apiEndpoint={"aed/storage-info"}
              idKey={"storage_info_id"}
              valueKey={"storage_info_name"}
              parentKey={""}
              onSelect={(e,value) => {
                handleInput(e);
              }}
              shouldFetchOnOpen={true}
              isCache={true}
              />

            {/* <select
              className="form-control"
              id=""
              name="storage_type"
              value={formData?.storage_type}
              onChange={handleInput}
            >
              <option value="" key={0} selected>
                --Select One--
              </option>
              {StorageList &&
                StorageList.map((item) => (
                  <option value={item?.storage_info_id}>
                    {item?.storage_info_name}
                  </option>
                ))}
            </select> */}
          </div>

          {Number(formData?.storage_type) === 1 && (
            <div className="col-2">
              <Form.Group>
                <b className={"d-block mb-2"}>Alarmed</b>
                <div className="">
                  <CustomToggleButton
                    ToggleName="alarmed"
                    ToggleValue={formData?.alarmed}
                    changeHandler={handleCheckBox2}
                  />
                </div>
              </Form.Group>
            </div>
           )}

          {Number(formData?.storage_type) === 1 && (
            <div className="col-2">
              <Form.Group>
                <b className={"d-block mb-2"}>Alarm Status</b>
                <div className="">
                  <CustomToggleButton
                    ToggleName="alarm_status"
                    ToggleValue={formData?.alarm_status}
                    changeHandler={handleAlarmStatus}
                  />
                </div>
              </Form.Group>
            </div>
          )}

          {(Number(formData?.alarmed) === 1 || formData?.alarmed) ? (
            <div className="col-3 form-group">
              <label htmlFor="">9v Installed Date</label>
              <CommonDatePicker
                calName={"v9_Installed_Date"}
                CalVal={formData?.v9_Installed_Date}
                HandleChange={handleDateChange}
              />
            </div>
          ) : (
            <> </>
          )}
        </div>
      </div>
    </>
  );
}

export default StorageInformation;
